import axios from 'axios';

const updateCouponApi = async (token, values, langIsoCode) => {
  try {
    const res = await axios.post('/Coupon/update', values, {
      headers: {
        lang: langIsoCode || 'ar',
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + token
      }
    });
    return res;
  } catch (error) {
    throw new Error(error);
  }
};

export default updateCouponApi;
